import React from 'react';
import SpeechLanguagePathologyPageHeader from './speechlanguagepathology/SpeechLanguagePathologyPageHeader';
import SpeechLanguagePathologyPageSession from './speechlanguagepathology/SpeechLanguagePathologyPageSession';

function SpeechLanguagePathologyPage() {
  return (
    <div className="page-wrapper">
      <SpeechLanguagePathologyPageHeader />
      <SpeechLanguagePathologyPageSession />
    </div>
  );
}

export default SpeechLanguagePathologyPage;
